import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../Services/auth';
import { AlertService } from '../Services/alert';
import { Config } from '../Services/config';
import { Settings } from '../Models/settings';


@Component({
  selector: 'password-reset',
  templateUrl: '../Templates/password.reset.html',
})


export class PasswordResetComponent implements OnInit {

  password: string;
  password_check: string;
  uid: string;
  token: string;

  settings: Settings;

  // Form submitted?
  submitted = false;

  constructor(private authService: AuthService,
              private msg: AlertService,
              private config: Config,
              private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.uid = params['uid'];
      this.token = params['token'];
    });

    this.config.getSettings().subscribe(
      settings => { this.settings = settings }
    );
  }

  reset(): void {

    if (this.submitted) {
      this.msg.error('Form already submitted');
    }

    this.submitted = true;

    var data = {'uid': this.uid,
                'token': this.token,
                'new_password1': this.password,
                'new_password2': this.password_check};

    this.authService.resetPwd(data).subscribe(
      data => {
        this.msg.success("Your password has been reset. Please login");
      }
    );
  }

  /**
   * Check whether passwords are touched and the same.
   * TODO: this is a copy of the one in register.ts. DRY!
   */
  public checkPassword(pwd1, pwd2): boolean {

    if (!((pwd1.dirty || pwd1.touched) && (pwd2.dirty || pwd2.touched))) {
      return true;
    }

    if (this.password != this.password_check) {
      return false;
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/password.reset.ts